export default {
  title: 'v{version}',
  notification: 'New version <strong>{version}</strong> available.</br>Refresh the page.',

  notifications: {
    copied: 'Version copied'
  }
}
